'use client';

import LinkButton from '@/_components/Ui/LinkButton';
import { HERO_QUERYResult, urlFor } from '@/_sanity';
import Image from 'next/image';

const Hero = ({ hero }: { hero: HERO_QUERYResult }) => {
  const heroBgImageUrl = hero?.bgimage?.asset?._ref ? urlFor(hero.bgimage?.asset)?.url() : '';

  // const titleTextColor = `text-${hero?.titletextcolor?.label ?? 'stonerwhitebg-text'}`;
  const titleTextColor = 'stonerwhitebg-text';
  const catchPhraseTextColor = 'stonerwhitebg-text';
  // const catchPhraseTextColor = `text-${hero?.catchphrasetextcolor?.label ?? 'stonerwhitebg-text'}`;
  // const ctaLeftLink = hero?.ctarleftlink || '';
  const ctaLeftText = hero?.ctalefttext || '';
  // const ctaLeftBgColor = `bg-${hero?.ctaleftbgcolor?.label ?? 'policeblue'}`;
  // const ctaLeftBgColorHover = `hover:bg-${hero?.ctaleftbgcolorhover?.label ?? 'moonstoneblue'}`;
  // const ctaLeftTextColor = `text-${hero?.ctalefttextcolor?.label ?? 'st onerwhite'}`;
  // const ctaLeftTextColorHover = `hover:text-${hero?.ctalefttextcolorhover?.label ?? 'policeblue'}`;
  // const ctaRightLink = hero?.ctarightlink || '';
  const ctaRightText = hero?.ctarighttext || '';
  // const ctaRightBgColor = `bg-${hero?.ctarightbgcolor?.label ?? 'moonstoneblue'}`;
  // const ctaRightBgColorHover = `hover:bg-${hero?.ctarightbgcolorhover?.label ?? 'policeblue'}`;
  // const ctaRightTextColor = `text-${hero?.ctarighttextcolor?.label ?? 'policeblue'}`;
  // const ctaRightTextColorHover = `hover:text-${hero?.ctarighttextcolorhover?.label ?? 'stonerwhite'}`;
  // const BgImageAltText = hero?.alttext || 'Background Image';
  const BgImageAltText = 'Hero Background Image';

  const CtaContent = () => {
    return (
      <div className="gap-4 flex w-full flex-col">
        <h1 className={`${titleTextColor}`}>{hero?.titletext}</h1>
        <h2 className={`${catchPhraseTextColor}`}>{hero?.catchphrasetext}</h2>

        {hero?.catchphraseauthortext && (
          <h1 className={`${catchPhraseTextColor}`}>{hero?.catchphraseauthortext}</h1>
        )}

        <div className="gap-4 sm:flex-row flex flex-row items-center">
          <LinkButton
            href="#contact-section"
            text={ctaLeftText}
            bg="bg-policebluebg"
            hoverBg="hover:bg-moonstonebluebg"
            textColor="text-stonerwhite"
            hoverTextColor="hover:text-moonstonebluebg-text"
          />
          <LinkButton
            href="#contact-section"
            text={ctaRightText}
            bg="bg-moonstonebluebg"
            hoverBg="hover:bg-policebluebg"
            textColor="text-moonstonebluebg-text"
            hoverTextColor="hover:text-stonerwhite"
          />
        </div>
      </div>
    );
  };

  const ImageContent = () => {
    if (heroBgImageUrl) {
      return (
        <div className="rounded-lg relative h-full w-full">
          <Image
            src={`${heroBgImageUrl || ''}`}
            alt={BgImageAltText}
            layout="fill"
            objectFit="contain"
            className="rounded-lg h-full w-full"
            priority
          />
        </div>
      );
    }
  };

  // p-4 sm:px-6 sm:pt-6 md:h-[35vh] md:px-8 md:pt-8 lg:px-10 lg:pt-10 xl:px-12 xl:pt-12

  return (
    <section className="herobg px-4 pt-4 sm:px-6 sm:pt-6 md:h-[35vh] md:px-8 md:pt-8 lg:px-10 lg:pt-10 xl:px-12 xl:pt-12 flex h-full justify-center">
      <div
        className={`md:flex-row container flex h-full w-full flex-col ${hero?.imageposition === 'right' ? 'md:flex-row-reverse' : ''} gap-4 items-center`}
      >
        <div className="md:order-0 order-1 h-full w-full">{ImageContent()}</div>

        <div className="md:order-0 lg:w-7/12 order-2 h-full w-full">{CtaContent()}</div>
      </div>
    </section>
  );
};

export default Hero;
